import {Button, Divider, Input, InputNumber, Modal, Select} from "antd";
import {PlusOutlined} from "@ant-design/icons";

const Option = Select.Option;
export default function AddAccessGroup({props}) {

  const accessTypes = [
    { label: "Renewal", value: "Renewal" },
    { label: "Single Course", value: "SingleCourse" },
    { label: "Annual", value: "AnnualSubscription" },
  ];

  return <Modal
      visible={props.visible}
      title="Add New Access Group"
      onOk={props.createAccessGroup}
      onCancel={props.handleCancel}
      footer={[
        <Button key="back"
                onClick={props.handleCancel}>
          Return
        </Button>,
        <Button type="primary"
                key="submit"
                className={'btn btn-success'}
                loading={props.loading}
                onClick={props.createAccessGroup}>
          Submit
        </Button>
      ]}>
    <div className="p-2">
      <span>Name</span>
      <Input placeholder="Input Access Group Name"
             value={props.name}
             onChange={(e) => props.setName(e.target.value)}/>
    </div>

    <div className="p-2">
      <span>Duration</span>
      <InputNumber placeholder="Input Duration(Days)"
                   className="w-100percent"
                   min={1}
                   max={100000}
                   value={props.duration}
                   onChange={(e) => props.setDuration(e)} />
    </div>

    <div className="p-2">
      <span>Fees</span>
      <InputNumber placeholder="Input Fee"
                   className="w-100percent"
                   min={1}
                   max={1000000}
                   value={props.fees}
                   onChange={(e) => props.setFees(e)} />
    </div>

    <div className="p-2">
      <span>Access Type</span>
      <Select value={props.accessType}
              onChange={(e) => props.setAccessType(e)}
              dropdownRender={menu => (
                  <div>
                    {menu}
                    <Divider style={{ margin: '4px 0' }} />
                    <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
                      <Input style={{ flex: 'auto' }}
                             value={props.newAccessType}
                             onChange={(e) => props.setNewAccess(e.target.value)} />
                      <a style={{ flex: 'none', padding: '8px', display: 'block', cursor: 'pointer' }}
                         onClick={(e) => props.setAccessType(props.newAccessType)}>
                        <PlusOutlined /> Add item
                      </a>
                    </div>
                  </div>
              )}
              size="default"
              placeholder={'Select AccessType'}
              className="w-100percent ant-input mw-150">
        {accessTypes?.map((mode, index) => (
            <Option value={mode.value} key={index}>
              {mode.label}
            </Option>
        ))}
      </Select>
    </div>
  </Modal>
}
